import {
    Box,
    Card,
    Chip,
    Typography
} from "@mui/material";
import React from "react";
import {statusColors} from "./ProjectDetailsDump";
import paths from "../../paths";
import {useNavigate} from "react-router";


function ProjectBox({project}) {
    const navigate = useNavigate();

    const handleNavigate = (e) => {
        e.stopPropagation();
        navigate(paths.project(project.id))
    }
    return (
        <Card
            onClick={(e) => handleNavigate(e)}
            sx={{
                m: 3,

                display: "flex",
                flexDirection: "row",
                cursor: "pointer",
                p: 1,
                alignItems: "center",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
            }}
        >
            <Box
                borderRight="1px dashed #ccc"
                width="30%"
            >
                <Box sx={{ml: 2, mr: 2, mb: 1, display: "flex", flexDirection: "column", alignItems: "space-between"}}>
                    <Typography
                        variant="h6"
                    >
                        {project.name}
                    </Typography>
                    <Box
                        id="client-box"
                        sx={{alignItems: "center", display: "flex", flexDirection: "column",}}
                    >
                        {project.client && (<>
                                <Typography variant="subtitle1">
                                    {project.client.contact_person}
                                </Typography>

                                <Typography variant="subtitle2">
                                    {project.client.company_name}
                                </Typography>
                            </>
                        )}
                    </Box>
                </Box>

            </Box>
            <Box
                borderRight="1px dashed #ccc"
                width={"30%"}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        pl: 3,
                        pr: 3,
                        mb: 2
                    }}
                >
                    <Typography>
                        Status
                    </Typography>
                    <Chip
                        label={project.status_display}
                        size="small"
                        sx={{
                            backgroundColor: `${statusColors[`${project.status}_bcg`]}`,
                            color: `${statusColors[`${project.status}_color`]}`,
                            fontWeight: "medium",
                            fontSize: 12,
                            height: 24,
                            borderRadius: "22px",
                            ml: 1
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        pl: 3,
                        pr: 3,
                    }}
                >
                    <Typography>
                        Budżet
                    </Typography>
                    <Chip
                        label={project.budget + " zł"}
                        size="medium"
                        sx={{
                            ml: 1,
                            fontWeight: "medium",
                            fontSize: 14,
                            height: 24,
                            borderRadius: "22px",
                        }}
                    />
                </Box>

            </Box>
            <Box
                sx={{
                    ml: 3,
                    width: "40%"
                }}
            >
                <Typography
                    variant={"subtitle1"}
                    gutterBottom
                >
                    Opis
                </Typography>
                <Typography variant={"body2"}>
                    {project.description}
                </Typography>
            </Box>
        </Card>
    );
}

const ProjectListDump = ({
                             projects
                         }) => {
    return (
        <Card
            sx={{borderRadius: 5}}
        >
            <Box
                id="project-list-header"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: "row",
                    justifyContent: "space-between",
                    p: 3,
                    borderBottom: '1px solid #d6d6d6',
                }}>
                <Typography variant="h4">
                    Ostatnie projekty
                </Typography>
            </Box>
            <Box>
                {projects && projects.length > 0 ? (
                    projects.map((project) => (
                        <ProjectBox key={project.id} project={project}/>
                    ))
                ) : (
                    <Typography variant="body1" sx={{ m: 4 }}>
                        Nie masz jeszcze żadnych projektów
                    </Typography>
                )}
            </Box>
        </Card>

    )
}

export default ProjectListDump;